import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { z } from 'zod';

const STRIPE_KEY = z
  .string({
    invalid_type_error:
      'Unable to parse PUBLIC_STRIPE_KEY. Included in env file?',
  })
  .parse(process.env.PUBLIC_STRIPE_KEY);

export function StripeContainer({ children }: { children: React.ReactNode }) {
  const stripe = loadStripe(STRIPE_KEY);

  if (stripe === null) {
    return null;
  }

  return (
    <>
      <Elements stripe={stripe}>{children}</Elements>
    </>
  );
}
